$(document).ready(function() {
	
	// autocomplete form functionality
	if ($('#autocomplete-form').length > 0) {
		autocomplete();
		initialSearchForm();
	}
	
	$('.pcam-basic-slideshow').each(function(index, slideshow) {
		var slideshow = $(slideshow).flickity({
			adaptiveHeight: true,
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			prevNextButtons: true,
			wrapAround: true
		});
	});
	
	$('.pcam-faq-question').on('click', function() {
		$(this).parents('.pcam-faq').toggleClass('pcam-faq-active');
	});
	
});